import { useQuery } from '@apollo/client/react';
import { Text } from '@loomhq/lens';
import cn from 'classnames';
import React from 'react';

import { DESTINATION_RELATED_VIDEOS } from 'constants/featureFlag';
import { SHARE_CONTEXT } from 'constants/videoCard';

import { SectionTitleContext } from 'contexts/SectionTitleContext';

import SimilarVideosQuery from './graphql/similarVideos.graphql';

import FeatureFlaggedComponent from 'components/feature-flag-wrapper';
import VideoCard from 'components/video-card';

import styles from './styles.module.less';

export const SimilarVideoContainer = ({
  parentVideo,
  isVertical,
  commentsDisplayed,
}) => {
  const { data, loading, error } = useQuery(SimilarVideosQuery, {
    variables: { videoId: parentVideo.id, first: 3 },
    fetchPolicy: 'no-cache',
  });

  if (!data || loading || error) {
    return null;
  }

  const similarVideos =
    data?.similarVideos?.videos?.edges.map(edge => edge.node) ?? [];

  const title = 'Similar Videos';

  return similarVideos.length > 0 ? (
    <FeatureFlaggedComponent
      flag={DESTINATION_RELATED_VIDEOS}
      activationValues={[true]}
    >
      <div
        className={cn(
          isVertical && styles.similarVideoVertical,
          !isVertical && styles.similarVideoHorizontal,
          !isVertical && commentsDisplayed && styles.hiddenHorizontalView
        )}
      >
        <Text size="large" fontWeight="medium">
          {title}
        </Text>
        <div className={cn(styles.similarVideosContainer)}>
          <SectionTitleContext.Provider value={title}>
            {similarVideos.map((video, idx) => (
              <div
                key={`similar-video-${idx}-${video.id}`}
                className={cn(styles.videoCardContainer)}
              >
                <VideoCard video={video} context={SHARE_CONTEXT} />
              </div>
            ))}
          </SectionTitleContext.Provider>
        </div>
      </div>
    </FeatureFlaggedComponent>
  ) : null;
};

export default SimilarVideoContainer;
